import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import Navigation from '../Navigation/Navigation';
import { convertToTree } from '../../utils/MenuUtils';
import styles from './NavigationSideBar.scss';
import Elevator from '../Elevator';
import CustomerDetailsSummary from '../CustomerDetailsSummary';
import { FLOW_STEP } from '../../stateManagement/engine/reducers/SessionReducer';
import { getFormattedTimeGuarantee } from '../AddressInformation/addressInformationUtils';
import { translate } from 'react-i18next';

//todo masha FIX when open customer info navigation should be hidden

export const NavigationSideBarDataHooks = {
  customerDetailsSummary: 'customer-details-summary-wrapper',
  deliveryInfo: 'address-details',
};

class NavigationSideBar extends React.PureComponent {
  static propTypes = {
    simplifiedMenu: PropTypes.object,
    locale: PropTypes.string,
    deliveryType: PropTypes.string,
    timezone: PropTypes.string,
    query: PropTypes.string,
    filters: PropTypes.object,
    showSummary: PropTypes.bool,
    onSummaryTitleClick: PropTypes.func,
    customer: PropTypes.object,
    address: PropTypes.object,
    onCustomerInfoClick: PropTypes.func,
    onAddressDetailsClick: PropTypes.func,
    onOrderHistoryClick: PropTypes.func,
    organizationAddress: PropTypes.string,
    step: PropTypes.string,
    shouldDisplayOrderHistory: PropTypes.bool,
    organization: PropTypes.object,
    t: PropTypes.func,
  };

  static defaultProps = {
    simplifiedMenu: {},
    route: [],
    onSummaryTitleClick: () => {},
    customer: {},
    address: {},
  };

  constructor(props) {
    super(props);
    const { simplifiedMenu, locale, deliveryType, timezone } = props;

    this.state = {
      tree: convertToTree({ simplifiedMenu, locale, deliveryType, timezone }),
      selectedLeaf: '',
      selectedSection: '',
    };
  }

  static getDerivedStateFromProps(props, state) {
    const newTree = convertToTree(props);
    let newState = null;

    if (!isEqual(state.tree, newTree)) {
      newState = {
        tree: newTree,
      };
    }

    return newState;
  }

  render() {
    const { tree } = this.state;
    const {
      query,
      filters,
      showSummary,
      onSummaryTitleClick,
      address,
      customer,
      deliveryType,
      onCustomerInfoClick,
      onAddressDetailsClick,
      onOrderHistoryClick,
      organizationAddress,
      selectedSection,
      selectedLeaf,
      onSelect,
      step,
      shouldDisplayOrderHistory,
      t,
      organization,
    } = this.props;
    const _customer = customer || {};
    const _address = address || {};
    const primary = (
      <Navigation
        tree={tree}
        selectedSection={selectedSection}
        selectedLeaf={selectedLeaf}
        onSelect={onSelect}
        collapse={!!query || !isEmpty(filters)}
      />
    );

    const formattedTimeGuarantee = getFormattedTimeGuarantee({
      localDeliveryType: deliveryType,
      localAddress: _address,
      t,
      organization,
    });

    const secondary = (
      <CustomerDetailsSummary
        name={_customer.firstName + ' ' + _customer.lastName}
        phoneNumber={_customer.phone}
        email={_customer.email}
        address={_address.formatted}
        apt={_address.apt}
        floor={_address.floor}
        entrance={_address.entrance}
        onArrival={_address.onArrival}
        instructions={_address.comment}
        deliverBy={formattedTimeGuarantee}
        deliveryType={deliveryType}
        onHeaderClick={onSummaryTitleClick}
        isExpanded={showSummary}
        onCustomerInfoClick={onCustomerInfoClick}
        onAddressDetailsClick={onAddressDetailsClick}
        onOrderHistoryClick={onOrderHistoryClick}
        shouldDisplayOrderHistory={shouldDisplayOrderHistory}
        organizationAddress={organizationAddress}
        displayChevron={step !== FLOW_STEP.CHECKOUT}
      />
    );

    return (
      <Elevator className={styles.wrapper} primary={primary} secondary={secondary} isSecondaryVisible={showSummary} />
    );
  }
}

export default translate()(NavigationSideBar);
